import { compose, withHandlers, withProps, withState } from 'recompose';

import withToggle from '../hoc/withToggle';

const MultiselectContainer = compose(
  withToggle('opened'),
  withState('selectedItems', 'setSelectedItems', props => props.defaultSelected || []),
  withProps(props => ({
    areAllSelected: props.selectedItems.length === (props.options || []).length,
  })),
  withHandlers({
    isOptionSelected: props => value => props.selectedItems.includes(value),
    setSelectedItems: props => (values) => {
      props.setSelectedItems(values);
      if (props.onChange) {
        props.onChange(values);
      }
    },
  }),
  withHandlers({
    toggleOption: props => (value) => {
      const isSelected = props.isOptionSelected(value);
      const nextState = isSelected
        ? props.selectedItems.filter(item => item !== value)
        : [...props.selectedItems, value];

      props.setSelectedItems(nextState);
    },
    toggleAll: props => () => {
      const nextState = props.areAllSelected
        ? []
        : (props.options || []).map(option => option.value);

      props.setSelectedItems(nextState);
    },
  }),
);

export default MultiselectContainer;
